import {
  createRouter,
  createWebHistory
} from "vue-router";
import Home from "../views/Home.vue";

const routes = [{
  path: '/',
  redirect: '/dashboard'
}, {
  path: "/",
  name: "Home",
  component: Home,
  children: [{
    path: "/dashboard",
    name: "dashboard",
    meta: {
      title: '系统首页'
    },
    component: () => import("../views/Dashboard.vue")
  },

    {
      path: "/service",
      name: "service",
      meta: {
        title: '客服聊天',
      },
      component: () => import("../views/service.vue")
    },
    {
      path: "/returnVisit",
      name: "returnVisit",
      meta: {
        title: '回访'
      },
      component: () => import("../views/returnVisit.vue")
    },
    {
      path: "/addReturns",
      name: "addReturns",
      meta: {
        title: '充值'
      },
      component: () => import("../views/addReturns.vue")
    },
    {
      path: "/customer",
      name: "customer",
      meta: {
        title: '我的客户'
      },
      component: () => import("../views/customer.vue")
    },
    {
      path: "/CRMHigh",
      name: "CRMHigh",
      meta: {
        title: '公海客户'
      },
      component: () => import("../views/CRMHigh.vue")
    },
    {
      path: "/CRMDepartmentHigh",
      name: "CRMDepartmentHigh",
      meta: {
        title: '部门公海'
      },
      component: () => import("../views/CRMDepartmentHigh.vue")
    },
    {
      path: "/frequencyLimiting",
      name: "frequencyLimiting",
      meta: {
        title: '出库限频'
      },
      component: () => import("../views/frequencyLimiting.vue")
    },
    {
      path: "/CRMstatistics",
      name: "CRMstatistics",
      meta: {
        title: 'CRM统计报表'
      },
      component: () => import("../views/CRMstatistics.vue")
    },
    {
      path: "/clue",
      name: "clue",
      meta: {
        title: '线索列表'
      },
      component: () => import("../views/clue.vue")
    },
    {
      path: "/groupCall",
      name: "groupCall",
      meta: {
        title: '群呼列表'
      },
      component: () => import("../views/groupCall.vue")
    },
    {
      path: "/taskDesk",
      name: "taskDesk",
      meta: {
        title: '任务中心'
      },
      component: () => import("../views/taskDesk.vue")
    },
    {
      path: "/cluePool",
      name: "cluePool",
      meta: {
        title: '线索池'
      },
      component: () => import("../views/cluePool.vue")
    },
    {
      path: "/assignLeads",
      name: "assignLeads",
      meta: {
        title: '线索回收'
      },
      component: () => import("../views/assignLeads.vue")
    },
    {
      path: "/qualityInspection",
      name: "qualityInspection",
      meta: {
        title: '录音质检'
      },
      component: () => import("../views/qualityInspection.vue")
    }, {
      path: "/qualityInspection2",
      name: "qualityInspection2",
      meta: {
        title: '录音检测'
      },
      component: () => import("../views/qualityInspection2.vue")
    }, {
      path: "/inspectionRecords",
      name: "inspectionRecords",
      meta: {
        title: '质检记录'
      },
      component: () => import("../views/inspectionRecords.vue")
    },
    {
      path: "/riskList",
      name: "riskList",
      meta: {
        title: '风险通话列表'
      },
      component: () => import("../views/riskList.vue")
    },
    {
      path: "/riskList2",
      name: "riskList2",
      meta: {
        title: '风险通话列表'
      },
      component: () => import("../views/riskList2.vue")
    }, {
      path: "/AIinspection",
      name: "AIinspection",
      meta: {
        title: 'AI质检'
      },
      component: () => import("../views/AIinspection.vue")
    },
    {
      path: "/record",
      name: "record",
      meta: {
        title: '通话记录'
      },
      component: () => import("../views/record.vue")
    },
    {
      path: "/recording",
      name: "recording",
      meta: {
        title: '录音检测'
      },
      component: () => import("../views/recording.vue")
    },
    {
      path: "/tag",
      name: "tag",
      meta: {
        title: '标签管理',
      },
      component: () => import("../views/tag.vue")
    },

    {
      path: "/customTag",
      name: "customTag",
      meta: {
        title: '字段配置',
      },
      component: () => import("../views/customTag.vue")
    },
    {
      path: "/clueCollection",
      name: "clueCollection",
      meta: {
        title: '领取记录',
      },
      component: () => import("../views/clueCollection.vue")
    },
    {
      path: "/operationRecord",
      name: "operationRecord",
      meta: {
        title: '操作记录',
      },
      component: () => import("../views/operationRecord.vue")
    },
    {
      path: "/CRMsource",
      name: "CRMsource",
      meta: {
        title: '来源配置',
      },
      component: () => import("../views/CRMsource.vue")
    }, {
      path: "/release",
      name: "release",
      meta: {
        title: '释放管理',
      },
      component: () => import("../views/release.vue")
    }, {
      path: "/modou",
      name: "modou",
      meta: {
        title: '模板',
      },
      component: () => import("../views/modou.vue")
    },
    {
      path: "/automaticRecycling",
      name: "automaticRecycling",
      meta: {
        title: '自动回收',
      },
      component: () => import("../views/automaticRecycling.vue")
    },

    {
      path: "/followProgress",
      name: "followProgress",
      meta: {
        title: '跟进阶段配置',
      },
      component: () => import("../views/followProgress.vue")
    },
    {
      path: "/company",
      name: "company",
      meta: {
        title: '企业列表',
        role: ['admin', 'agent', 'subAgent']
      },
      component: () => import("../views/company.vue")
    },

    {
      path: "/deleteRecords",
      name: "deleteRecords",
      meta: {
        title: '删除记录',
        role: ['admin']
      },
      component: () => import("../views/deleteRecords.vue")
    },
    {
      path: "/department",
      name: "department",
      meta: {
        title: '部门管理'
      },
      component: () => import("../views/department.vue")
    }, {
      path: "/user",
      name: "user",
      meta: {
        title: '员工管理'
      },
      component: () => import("../views/user.vue")
    }, {
      path: "/report",
      name: "report",
      meta: {
        title: '员工统计报表',
        permission: true,
        role: ['admin', 'agent', 'company', 'department', 'subAgent']
      },
      component: () => import("../views/report.vue")
    }, {
      path: "/companyStatistics",
      name: "companyStatistics",
      meta: {
        title: '公司统计报表',
        permission: true,
        role: ['admin', 'agent', 'company', 'department', 'subAgent']
      },
      component: () => import("../views/companyStatistics.vue")
    }, {
      path: "/GSAxb",
      name: "GSAxb",
      meta: {
        title: '光速AXB',
        permission: true,
        role: ['admin', 'agent', 'company', 'department', 'subAgent']
      },
      component: () => import("../views/GSAxb.vue")
    }, {
      path: "/cjabnormalCall",
      name: "cjabnormalCall",
      meta: {
        title: '长江异常话单',
        permission: true,
        role: ['admin', 'agent', ]
      },
      component: () => import("../views/cjabnormalCall.vue")
    }, {
      path: "/agent",
      name: "agent",
      meta: {
        title: '代理商管理',
        permission: true,
        role: ['admin', 'oem']
      },
      component: () => import("../views/agent.vue")
    }, {
      path: "/administratorAccount",
      name: "administratorAccount",
      meta: {
        title: '管理员账号',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/administratorAccount.vue")
    },
    // {
    // 	path: "/blackListDatabase",
    // 	name: "blackListDatabase",
    // 	meta: {
    // 		title: '黑名单库',
    // 		permission: true,
    // 		role: ['admin', 'agent', 'subAgent']
    // 	},
    // 	component: () => import(
    // 		/* webpackChunkName: "table" */
    // 		"../views/blackListDatabase.vue")
    // },
    {
      path: "/cardType",
      name: "cardType",
      meta: {
        title: '品牌管理',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
        visiable: true,
      },
      component: () => import("../views/cardType.vue")
    }, {
      path: "/businessRecords",
      name: "businessRecords",
      meta: {
        title: '业务记录',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/businessRecords.vue")
    },
    {
      path: "/numberPool",
      name: "numberPool",
      meta: {
        title: '号码池',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/numberPool.vue")
    }, {
      path: "/woniunumberPool",
      name: "woniunumberPool",
      meta: {
        title: '蜗牛号码池',
        permission: true,
        role: ['admin', 'oem'],
        visiable: true,
      },
      component: () => import("../views/woniunumberPool.vue")
    }, {
      path: "/numberControl",
      name: "numberControl",
      meta: {
        title: '漫游管控',
        permission: true,
        role: ['admin', 'agent'],
        visiable: true,
      },
      component: () => import("../views/numberControl.vue")
    }, {
      path: "/accountOpeningProgress",
      name: "accountOpeningProgress",
      meta: {
        title: '蜗牛开户进度',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/accountOpeningProgress.vue")
    }, {
      path: "/accountOpeningProgressCY",
      name: "accountOpeningProgressCY",
      meta: {
        title: 'CY蜗牛开户进度',
        permission: true,
        role: ['admin', 'agent'],
        visiable: true,
      },
      component: () => import("../views/accountOpeningProgressCY.vue")
    }, {
      path: "/batchAccountClosure",
      name: "batchAccountClosure",
      meta: {
        title: '批量销户',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/batchAccountClosure.vue")
    }, {
      path: "/batchAccountClosureCY",
      name: "batchAccountClosureCY",
      meta: {
        title: 'CY批量销户',
        permission: true,
        role: ['admin', 'agent'],
        visiable: true,
      },
      component: () => import("../views/batchAccountClosureCY.vue")
    },
    {
      path: "/woniuRecharge",
      name: "woniuRecharge",
      meta: {
        title: '充值列表',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/woniuRecharge.vue")
    },
    {
      path: "/blackNameList",
      name: "blackNameList",
      meta: {
        title: '风险黑名单',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/blackNameList.vue")
    },
    {
      path: "/subagent",
      name: "subagent",
      meta: {
        title: '子代理列表',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
        visiable: true,
      },
      component: () => import("../views/subagent.vue")
    },
    {
      path: "/woniuBill",
      name: "woniuBill",
      meta: {
        title: '蜗牛话单',
        permission: true,
        role: ['admin', 'oem'],
        visiable: true,
      },
      component: () => import("../views/woniuBill.vue")
    },
    {
      path: "/outboundCallRecords",
      name: "outboundCallRecords",
      meta: {
        title: '外呼记录',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
        visiable: true,
      },
      component: () => import("../views/outboundCallRecords.vue")
    }, {
      path: "/shutdownRecord",
      name: "shutdownRecord",
      meta: {
        title: '蜗牛停机记录',
        permission: true,
        role: ['admin', 'oem'],
        visiable: true,
      },
      component: () => import("../views/shutdownRecord.vue")
    }, {
      path: "/hySA",
      name: "hySA",
      meta: {
        title: '华云SA查询',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
        visiable: true,
      },
      component: () => import("../views/hySA.vue")
    }, /* {
      path: "/tagQuery",
      name: "tagQuery",
      meta: {
        title: '标记查询',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
        visiable: true,
      },
      component: () => import("../views/tagQuery.vue")
    }, */ {
      path: "/programmeManagement",
      name: "programmeManagement",
      meta: {
        title: '方案管理',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/programmeManagement.vue")
    },
    {
      path: "/webClue",
      name: "webClue",
      meta: {
        title: '网站线索',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/webClue.vue")
    }, {
      path: "/statistics",
      name: "statistics",
      meta: {
        title: '话单校验',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/statistics.vue")
    }, {
      path: "/restartRecordList",
      name: "restartRecordList",
      meta: {
        title: '迪加停复机',
        permission: true,
        role: ['admin', 'oem'],
        visiable: true,
      },
      component: () => import("../views/restartRecordList.vue")
    }, {
      path: "/CCrestartRecordList",
      name: "CCrestartRecordList",
      meta: {
        title: '长城停复机',
        permission: true,
        role: ['admin', 'oem'],
        visiable: true,
      },
      component: () => import("../views/CCrestartRecordList.vue")
    }, {
      path: "/DJfreeze",
      name: "DJfreeze",
      meta: {
        title: '自选套餐冻结',
        permission: true,
        role: ['admin', 'agent'],
        visiable: true,
      },
      component: () => import("../views/DJfreeze.vue")
    }, {
      path: "/WNrestartRecordList",
      name: "WNrestartRecordList",
      meta: {
        title: '蜗牛停复机',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
        visiable: true,
      },
      component: () => import("../views/WNrestartRecordList.vue")
    }, {
      path: "/WNrestartRecordListCY",
      name: "WNrestartRecordListCY",
      meta: {
        title: 'CY蜗牛停复机',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
        visiable: true,
      },
      component: () => import("../views/WNrestartRecordListCY.vue")
    }, {
      path: "/NoShutdownMaintenanceNumber",
      name: "NoShutdownMaintenanceNumber",
      meta: {
        title: '取消停机保号',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/NoShutdownMaintenanceNumber.vue")
    }, {
      path: "/userInfo",
      name: "userInfo",
      meta: {
        title: '迪加查询',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
        visiable: true,
      },
      component: () => import("../views/userInfo.vue")
    }, {
      path: "/wnQuery",
      name: "wnQuery",
      meta: {
        title: '蜗牛查询',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
        visiable: true,
      },
      component: () => import("../views/wnQuery.vue")
    }, {
      path: "/CCQuery",
      name: "CCQuery",
      meta: {
        title: '长城查询',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
        visiable: true,
      },
      component: () => import("../views/CCQuery.vue")
    }, {
      path: "/wnQueryCY",
      name: "wnQueryCY",
      meta: {
        title: 'CY蜗牛查询',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
        visiable: true,
      },
      component: () => import("../views/wnQueryCY.vue")
    }, {
      path: "/WNWhitelist",
      name: "WNWhitelist",
      meta: {
        title: '蜗牛批量加白',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/WNWhitelist.vue")
    }, {
      path: "/WNWhitelistCY",
      name: "WNWhitelistCY",
      meta: {
        title: 'CY蜗牛批量加白',
        permission: true,
        role: ['admin', 'agent'],
        visiable: true,
      },
      component: () => import("../views/WNWhitelistCY.vue")
    }, {
      path: "/djRecharge",
      name: "djRecharge",
      meta: {
        title: '迪加充值',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/djRecharge.vue")
    }, {
      path: "/wnRecharge",
      name: "wnRecharge",
      meta: {
        title: '蜗牛充值',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/wnRecharge.vue")
    }, {
      path: "/preDeposit",
      name: "preDeposit",
      meta: {
        title: '蜗牛预存款',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/preDeposit.vue")
    }, {
      path: "/frequencyLimit",
      name: "frequencyLimit",
      meta: {
        title: '呼叫限频',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/frequencyLimit.vue")
    }, {
      path: "/frequencyLimitCY",
      name: "frequencyLimitCY",
      meta: {
        title: 'CY呼叫限频',
        permission: true,
        role: ['admin', 'agent'],
        visiable: true,
      },
      component: () => import("../views/frequencyLimitCY.vue")
    }, {
      path: "/companyCardQuota",
      name: "companyCardQuota",
      meta: {
        title: '坐席配额',
        permission: true,
        role: ['admin', 'agent'],
        visiable: true,
      },
      component: () => import("../views/companyCardQuota.vue")
    }, {
      path: "/djRebateList",
      name: "djRebateList",
      meta: {
        title: '返销记录',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/djRebateList.vue")
    }, {
      path: "/activationList",
      name: "activationList",
      meta: {
        title: '限制返档',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
        visiable: true,
      },
      component: () => import("../views/activationList.vue")
    }, {
      path: "/DJAbnormalCallList",
      name: "DJAbnormalCallList",
      meta: {
        title: '迪加异常话单',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
        visiable: true,
      },
      component: () => import("../views/DJAbnormalCallList.vue")
    }, {
      path: "/CCWNAbnormalCallList",
      name: "CCWNAbnormalCallList",
      meta: {
        title: '长城异常话单',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
        visiable: true,
      },
      component: () => import("../views/CCWNAbnormalCallList.vue")
    }, {
      path: "/WNAbnormalCallList",
      name: "WNAbnormalCallList",
      meta: {
        title: '蜗牛异常话单',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
        visiable: true,
      },
      component: () => import("../views/WNAbnormalCallList.vue")
    }, {
      path: "/WNAbnormalCallListCY",
      name: "WNAbnormalCallListCY",
      meta: {
        title: 'CY蜗牛异常话单',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
        visiable: true,
      },
      component: () => import("../views/WNAbnormalCallListCY.vue")
    },
    {
      path: "/accountReview",
      name: "accountReview",
      meta: {
        title: '开户审核查询'
      },
      component: () => import("../views/accountReview.vue")
    },
    {
      path: "/workOrder",
      name: "workOrder",
      meta: {
        title: '工单管理',
        permission: true,
        role: ['admin', 'oem'],
        visiable: true,
      },
      component: () => import("../views/workOrder.vue")
    }, {
      path: "/agentSerial",
      name: "agentSerial",
      meta: {
        title: '代理商分配记录',
        permission: true,
        role: ['admin', 'oem']
      },
      component: () => import("../views/agentSerial.vue")
    },
    // {
    // 	path: "/userSerial",
    // 	name: "userSerial",
    // 	meta: {
    // 		title: '员工分配记录',
    // 		permission: true,
    // 		role: ['admin', 'agent', 'subAgent',

    // 	},
    // 	component: () => import(
    // 		/* webpackChunkName: "table" */
    // 		"../views/userSerial.vue")
    // },
    {
      path: "/flowManagement",
      name: "flowManagement",
      meta: {
        title: '流水管理',
        permission: true,
        role: ['admin', 'oem', 'agent']
      },
      component: () => import("../views/flowManagement.vue")
    },
    {
      path: "/refundList",
      name: "refundList",
      meta: {
        title: '退款列表',
        permission: true,
        role: ['admin', 'oem']
      },
      component: () => import("../views/refundList.vue")
    },
    {
      path: "/stopPhone",
      name: "stopPhone",
      meta: {
        title: '号码停机',
        permission: true,
        role: ['admin', 'agent', 'subAgent']
      },
      component: () => import("../views/stopPhone.vue")
    }, {
      path: "/validate",
      name: "validate",
      meta: {
        title: '号码验证'
      },
      component: () => import("../views/validate.vue")
    },
    {
      path: "/blackList",
      name: "blackList",
      meta: {
        title: '黑名单'
      },
      component: () => import("../views/blackList.vue")
    },
    // {
    // 	path: "/userManual",
    // 	name: "userManual",
    // 	meta: {
    // 		title: '用户手册'
    // 	},
    // 	component: () => import(
    // 		/* webpackChunkName: "table" */
    // 		"../views/userManual.vue")
    // },
    {
      path: "/swipes",
      name: "swipes",
      meta: {
        title: 'APP轮播图'
      },
      component: () => import("../views/swipes.vue")
    },
    {
      path: "/afterSales",
      name: "afterSales",
      meta: {
        title: '售后信息',
        role: ['admin', 'oem']
      },
      component: () => import("../views/afterSales.vue")
    },
    {
      path: "/role",
      name: "role",
      meta: {
        title: '角色管理',
        permission: true,
        role: ['admin', 'agent', 'subAgent']
      },
      component: () => import("../views/role.vue")
    }, {
      path: "/notice",
      name: "notice",
      meta: {
        title: '公告',
        permission: true,
        role: ['admin', 'agent', 'subAgent']
      },
      component: () => import("../views/notice.vue")
    },
    {
      path: "/addNotice",
      name: "addNotice",
      meta: {
        title: '发布公告',
        permission: true,
        role: ['admin', 'agent', 'subAgent']
      },
      component: () => import("../views/addNotice.vue")
    },
    {
      path: '/404',
      name: '404',
      meta: {
        title: '找不到页面'
      },
      component: () => import('../views/404.vue')
    }, {
      path: '/403',
      name: '403',
      meta: {
        title: '没有权限'
      },
      component: () => import('../views/403.vue')
    },
    {
      path: "/operationManual",
      name: "operationManual",
      meta: {
        title: '使用手册'
      },
      component: () => import("../views/operationManual.vue")
    }, {
      path: "/operationManual2",
      name: "operationManual2",
      meta: {
        title: '使用手册'
      },
      component: () => import("../views/operationManual2.vue")
    },
    {
      path: "/reportNumber",
      name: "reportNumber",
      meta: {
        title: '报备绿名单号码',
        permission: true,
        role: ['admin', 'oem', 'agent']
      },
      component: () => import("../views/reportNumber.vue")
    },
    {
      path: "/operationLog",
      name: "operationLog",
      meta: {
        title: '员工操作日志',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
      },
      component: () => import("../views/operationLog.vue")
    },
    {
      path: "/termOfValidity",
      name: "termOfValidity",
      meta: {
        title: '有效期管理',
        permission: true,
        role: ['admin', 'agent', 'subAgent'],
      },
      component: () => import("../views/termOfValidity.vue")
    },
    {
      path: "/setColor",
      name: "setColor",
      meta: {
        title: '设置主题',
        permission: true,
        role: ['admin', 'agent', 'company', 'department', 'normal', 'subAgent']
      },
      component: () => import("../views/setColor.vue")
    },
    {
      path: "/packageList",
      name: "packageList",
      meta: {
        title: '套餐列表',
        permission: true,
        role: ['admin', 'agent', 'company', 'department', 'normal', 'subAgent']
      },
      component: () => import("../views/packageList.vue")
    },
    {
      path: "/middleNumber",
      name: "middleNumber",
      meta: {
        title: '回拨中间号',
        permission: true,
        role: ['admin', 'agent', 'company', 'department', 'normal', 'subAgent']
      },
      component: () => import("../views/middleNumber.vue")
    },
    {
      path: "/consumptionDetails",
      name: "consumptionDetails",
      meta: {
        title: '消费明细',
        permission: true,
        role: ['admin', 'agent', 'company', 'department', 'normal', 'subAgent']
      },
      component: () => import("../views/consumptionDetails.vue")
    },
    {
      path: "/privateNumber",
      name: "privateNumber",
      meta: {
        title: '私人号码',
        permission: true,
        role: ['admin', 'agent', 'company', 'department', 'normal', 'subAgent']
      },
      component: () => import("../views/privateNumber.vue")
    },
    {
      path: "/packageManagement",
      name: "packageManagement",
      meta: {
        title: '套餐管理',
        permission: true,
        role: ['admin', 'agent', 'company', 'subAgent']
      },
      component: () => import("../views/packageManagement.vue")
    },
    {
      path: "/packageManagementX",
      name: "packageManagementX",
      meta: {
        title: '套餐管理',
        permission: true,
        role: ['admin', 'agent', 'company', 'subAgent']
      },
      component: () => import("../views/packageManagementX.vue")
    }, {
      path: "/packageManagementXuser",
      name: "packageManagementXuser",
      meta: {
        title: '用户管理',
        permission: true,
        role: ['admin', 'agent', 'company', 'subAgent']
      },
      component: () => import("../views/packageManagementXuser.vue")
    }, {
      path: "/AXBBinding",
      name: "AXBBinding",
      meta: {
        title: '绑定查询',
        permission: true,
        role: ['admin', 'agent']
      },
      component: () => import("../views/AXBBinding.vue")
    },
    {
      path: "/record2",
      name: "record2",
      meta: {
        title: '虚商通话记录',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/record2.vue")
    },
    {
      path: "/AXBinventory",
      name: "AXBinventory",
      meta: {
        title: 'AXB库存',
        permission: true,
        role: ['admin', 'agent', 'subAgent']
      },
      component: () => import("../views/AXBinventory.vue")
    },
    {
      path: "/SJTXinventory",
      name: "SJTXinventory",
      meta: {
        title: '世纪通信库存',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/SJTXinventory.vue")
    },
    {
      path: "/purchaseOrderList",
      name: "purchaseOrderList",
      meta: {
        title: '采购列表',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/purchaseOrderList.vue")
    },
    {
      path: "/whiteCard",
      name: "whiteCard",
      meta: {
        title: '白卡入库',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/whiteCard.vue")
    },
    {
      path: "/SJinventory",
      name: "SJinventory",
      meta: {
        title: '世纪通信库存',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/SJinventory.vue")
    },
    {
      path: "/SJDeliveryRecord",
      name: "SJDeliveryRecord",
      meta: {
        title: '世纪通信库存记录',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/SJDeliveryRecord.vue")
    },
    {
      path: "/outboundRecord",
      name: "outboundRecord",
      meta: {
        title: '出库记录',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/outboundRecord.vue")
    },
    {
      path: "/inventoryList",
      name: "inventoryList",
      meta: {
        title: '库存列表',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/inventoryList.vue")
    },
    {
      path: "/inventorySetMenu",
      name: "inventorySetMenu",
      meta: {
        title: '库存套餐',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/inventorySetMenu.vue")
    },
    {
      path: "/earlyWarning",
      name: "earlyWarning",
      meta: {
        title: '预警规则',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/earlyWarning.vue")
    }, {
      path: "/purchaseList",
      name: "purchaseList",
      meta: {
        title: '已购号码',
        permission: true,
        role: ['admin', 'agent', 'company', 'subAgent']
      },
      component: () => import("../views/purchaseList.vue")
    }, {
      path: "/consultationDetailed",
      name: "consultationDetailed",
      meta: {
        title: '消费明细',
        permission: true,
        role: ['admin', 'agent', 'company', 'subAgent']
      },
      component: () => import("../views/consultationDetailed.vue")
    },
    {
      path: "/seating",
      name: "seating",
      meta: {
        title: '坐席数据',
        permission: true,
        role: ['admin', 'agent', 'subAgent']
      },
      component: () => import("../views/seating.vue")
    },
    {
      path: "/userPhone",
      name: "userPhone",
      meta: {
        title: '账号登录记录',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/userPhone.vue")
    },
    {
      path: "/remoteLogin",
      name: "remoteLogin",
      meta: {
        title: '位置异常',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/remoteLogin.vue")
    },
    {
      path: "/jobManager",
      name: "jobManager",
      meta: { title: '定时任务管理' },
      role: ['admin'] ,// 只有 admin 能访问
      component: () => import("../views/job/JobManager.vue")
    },
    {
      path: "/callsNumber",
      name: "callsNumber",
      meta: {
        title: '电话邦放行次数',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/callsNumber.vue")
    },
    {
      path: "/GMvirtualCommerce",
      name: "GMvirtualCommerce",
      meta: {
        title: '国美管理',
        permission: true,
        role: ['admin', 'agent']
      },
      component: () => import("../views/GMvirtualCommerce.vue")
    },
    {
      path: "/WNvirtualCommerce",
      name: "WNvirtualCommerce",
      meta: {
        title: '蜗牛管理',
        permission: true,
        role: ['admin', 'agent']
      },
      component: () => import("../views/WNvirtualCommerce.vue")
    },
    {
      path: "/enterpriseLimiting",
      name: "enterpriseLimiting",
      meta: {
        title: '企业限频',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/enterpriseLimiting.vue")
    },
    {
      path: "/CYWNvirtualCommerce",
      name: "CYWNvirtualCommerce",
      meta: {
        title: 'CY蜗牛管理',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/CYWNvirtualCommerce.vue")
    },
    {
      path: "/DJvirtualCommerce",
      name: "DJvirtualCommerce",
      meta: {
        title: '迪加管理',
        permission: true,
        role: ['admin', 'agent'],
      },
      component: () => import("../views/DJvirtualCommerce.vue")
    },
    {
      path: "/CCvirtualCommerce",
      name: "CCvirtualCommerce",
      meta: {
        title: '长城管理',
        permission: true,
        role: ['admin', 'agent']
      },
      component: () => import("../views/CCvirtualCommerce.vue")
    },
    {
      path: "/gmAbnormalCallList",
      name: "gmAbnormalCallList",
      meta: {
        title: '国美异常话单',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/gmAbnormalCallList.vue")
    },
    {
      path: "/gmAbnormalNumber",
      name: "gmAbnormalNumber",
      meta: {
        title: '国美异常号码',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/gmAbnormalNumber.vue")
    },
    {
      path: "/highSeas",
      name: "highSeas",
      meta: {
        title: '公海数据',
        permission: true,
        role: ['admin', 'agent', 'company', 'department', 'normal', 'subAgent']
      },
      component: () => import("../views/highSeas.vue")
    },
    {
      path: "/advancedSearch",
      name: "advancedSearch",
      meta: {
        title: '找线索',
        permission: true,
        // role: ['admin'],
        role: ['admin', 'agent', 'company', 'department', 'normal', 'subAgent']
      },
      component: () => import("../views/advancedSearch.vue")
    }, {
      path: "/companySearch",
      name: "companySearch",
      meta: {
        title: '找企业',
        permission: true,
        role: ['admin', 'agent', 'company', 'department', 'normal', 'subAgent']
      },
      component: () => import("../views/companySearch.vue")
    }, {
      path: "/shopSearch",
      name: "shopSearch",
      meta: {
        title: '找店铺',
        permission: true,
        role: ['admin', 'agent', 'company', 'department', 'normal', 'subAgent']
      },
      component: () => import("../views/shopSearch.vue")
    }, {
      path: "/industryTemplate",
      name: "industryTemplate",
      meta: {
        title: '找行业',
        permission: true,
        role: ['admin', 'agent', 'company', 'department', 'normal', 'subAgent']
      },
      component: () => import("../views/industryTemplate.vue")
    }, {
      path: "/mapSearch",
      name: "mapSearch",
      meta: {
        title: '地图找客',
        permission: true,
        role: ['admin', 'agent', 'company', 'department', 'normal', 'subAgent']
      },
      component: () => import("../views/mapSearch.vue")
    }, {
      path: "/batchCheckCompany",
      name: "batchCheckCompany",
      meta: {
        title: '批量查询',
        permission: true,
        role: ['admin', 'agent', 'company', 'department', 'normal', 'subAgent']
      },
      component: () => import("../views/batchCheckCompany.vue")
    }, {
      path: "/poolAccount",
      name: "poolAccount",
      meta: {
        title: '寻迹通账号管理',
        permission: true,
        role: ['admin', 'agent', 'company', 'department', 'normal', 'subAgent']
      },
      component: () => import("../views/poolAccount.vue")
    },
    {
      path: "/guide",
      name: "guide",
      meta: {
        title: '指引',
        permission: true,
        role: ['admin', 'agent', 'company', 'department', 'normal', 'subAgent']
      },
      component: () => import("../views/guide.vue")
    },
    {
      path: "/GM",
      name: "GM",
      meta: {
        title: '国美录音',
        permission: true,
        role: ['gm']
      },
      component: () => import("../views/GM.vue")
    },
    {
      path: "/OEMset",
      name: "OEMset",
      meta: {
        title: 'OEM设置',
        permission: true,
        role: ['admin', 'agent', 'subAgent']
      },
      component: () => import("../views/OEMset.vue")
    },
    {
      path: "/OEMswiper",
      name: "OEMswiper",
      meta: {
        title: '登录轮播图',
        permission: true,
        role: ['admin', 'agent', 'subAgent']
      },
      component: () => import("../views/OEMswiper.vue")
    },
    {
      path: "/prestore",
      name: "prestore",
      meta: {
        title: '蜗牛预存款',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/prestore.vue")
    },
    {
      path: "/panelData",
      name: "panelData",
      meta: {
        title: '数据面板',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/panelData.vue")
    },
    {
      path: "/sipTemplate",
      name: "sipTemplate",
      meta: {
        title: '套餐列表',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/sipTemplate.vue")
    },
    {
      path: "/enterpriseAllocation",
      name: "enterpriseAllocation",
      meta: {
        title: '套餐分配',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/enterpriseAllocation.vue")
    },
    {
      path: "/specialServiceNumber",
      name: "specialServiceNumber",
      meta: {
        title: '号码列表',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/specialServiceNumber.vue")
    },
    {
      path: "/FTConsumptionDetails",
      name: "FTConsumptionDetails",
      meta: {
        title: '账单明细',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/FTConsumptionDetails.vue")
    },
    {
      path: "/JobData",
      name: "JobData",
      meta: {
        title: '数据面板',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/JobData.vue")
    },

    {
      path: "/JobTemplate",
      name: "JobTemplate",
      meta: {
        title: '套餐列表',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/JobTemplate.vue")
    },
    {
      path: "/JobenterpriseAllocation",
      name: "JobenterpriseAllocation",
      meta: {
        title: '套餐分配',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/JobenterpriseAllocation.vue")
    },
    {
      path: "/JobspecialServiceNumber",
      name: "JobspecialServiceNumber",
      meta: {
        title: '号码列表',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/JobspecialServiceNumber.vue")
    },
    {
      path: "/UUtemplate",
      name: "UUtemplate",
      meta: {
        title: 'U友模版',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/UUtemplate.vue")
    },
    {
      path: "/JobFTConsumptionDetails",
      name: "JobFTConsumptionDetails",
      meta: {
        title: '账单明细',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/JobFTConsumptionDetails.vue")
    },
    {
      path: "/JobFTConsumptionDetails",
      name: "JobFTConsumptionDetails",
      meta: {
        title: '账单明细',
        permission: true,
        role: ['admin']
      },
      component: () => import("../views/JobFTConsumptionDetails.vue")
    },
    {
      path: "/addressErrList",
      name: "addressErrList",
      meta: {
        title: '位置异常',
        permission: true,
        role: ['admin', 'agent']
      },
      component: () => import("../views/addressErrList.vue")
    },

    {
      path: "/customerQualityControl",
      name: "customerQualityControl",
      meta: {
        title: '客户质量管理',
        permission: true,
        role: ['admin', 'agent', 'company'],
      },
      component: () => import("../views/customerQualityControl.vue")
    },
    {
      path: "/tonglianPrecisionTube",
      name: "tonglianPrecisionTube",
      meta: {
        title: '云呼面板',
        permission: true,
        role: ['admin', 'agent', 'company'],
      },
      component: () => import("../views/tonglianPrecisionTube.vue")
    },
    {
      path: "/cdrBatchManagement",
      name: "cdrBatchManagement",
      meta: {
        title: '话批面板',
        permission: true,
        role: ['admin', 'agent', 'company'],
      },
      component: () => import("../views/cdrBatchManagement.vue")
    },
    {
      path: "/cdrBatchList",
      name: "cdrBatchList",
      meta: {
        title: '套餐列表',
        permission: true,
        role: ['admin', 'agent'],
      },
      component: () => import("../views/cdrBatchList.vue")
    },
    {
      path: "/cdrBatchAllocation",
      name: "cdrBatchAllocation",
      meta: {
        title: '企业套餐',
        permission: true,
        role: ['admin', 'agent', 'company'],
      },
      component: () => import("../views/cdrBatchAllocation.vue")
    },
    {
      path: "/trumpetspecialServiceNumber",
      name: "trumpetspecialServiceNumber",
      meta: {
        title: '号码状态',
        permission: true,
        role: ['admin', 'agent', 'company'],
      },
      component: () => import("../views/trumpetspecialServiceNumber.vue")
    },
    {
      path: "/cdrBatchType",
      name: "cdrBatchType",
      meta: {
        title: '号码状态',
        permission: true,
        role: ['admin', 'agent', 'company'],
      },
      component: () => import("../views/cdrBatchType.vue")
    },
    {
      path: "/cdrBatchConsumptionDetails",
      name: "cdrBatchConsumptionDetails",
      meta: {
        title: '账单明细',
        permission: true,
        role: ['admin', 'agent', 'company'],
      },
      component: () => import("../views/cdrBatchConsumptionDetails.vue")
    }, {
      path: "/cdrBatchPremium",
      name: "cdrBatchPremium",
      meta: {
        title: '溢价',
        permission: true,
        role: ['admin'],
      },
      component: () => import("../views/cdrBatchPremium.vue")
    },
    {
      path: "/cdrBatchServer",
      name: "cdrBatchServer",
      meta: {
        title: '话批品牌',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/cdrBatchServer.vue")
    },
    {
      path: "/quantitativeIntelligenceMonitoring",
      name: "quantitativeIntelligenceMonitoring",
      meta: {
        title: '通话数据管理',
        permission: true,
        role: ['admin', 'agent', 'company'],
      },
      component: () => import("../views/quantitativeIntelligenceMonitoring.vue")
    },
    {
      path: "/trumpetTemplate",
      name: "trumpetTemplate",
      meta: {
        title: '套餐列表',
        permission: true,
        role: ['admin', 'agent'],
      },
      component: () => import("../views/trumpetTemplate.vue")
    },
    {
      path: "/trumpetenterpriseAllocation",
      name: "trumpetenterpriseAllocation",
      meta: {
        title: '企业套餐',
        permission: true,
        role: ['admin', 'agent', 'company'],
      },
      component: () => import("../views/trumpetenterpriseAllocation.vue")
    },
    {
      path: "/sipNumber",
      name: "sipNumber",
      meta: {
        title: '号码列表',
        permission: true,
        role: ['admin', 'agent', 'company'],
        visiable: true,
      },
      component: () => import("../views/sipNumber.vue")
    }, {
      path: "/sipAccountPrice",
      name: "sipAccountPrice",
      meta: {
        title: '云呼号码价格',
        permission: true,
        role: ['admin', 'agent'],
        visiable: true,
      },
      component: () => import("../views/sipAccountPrice.vue")
    }, {
      path: "/trumpetFTConsumptionDetails",
      name: "trumpetFTConsumptionDetails",
      meta: {
        title: '账单明细',
        permission: true,
        role: ['admin', 'agent', 'company'],
      },
      component: () => import("../views/trumpetFTConsumptionDetails.vue")
    }, {
      path: "/premium",
      name: "premium",
      meta: {
        title: '溢价',
        permission: true,
        role: ['admin', 'agent'],
      },
      component: () => import("../views/premium.vue")
    }, {
      path: "/SIPServer",
      name: "SIPServer",
      meta: {
        title: '云呼服务器',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/SIPServer.vue")
    },
    {
      path: "/gmQuery",
      name: "gmQuery",
      meta: {
        title: '国美查询',
        permission: true,
        role: ['admin', 'agent'],
        visiable: true,
      },
      component: () => import("../views/gmQuery.vue")
    },
    {
      path: "/gmRecharge",
      name: "gmRecharge",
      meta: {
        title: '国美充值',
        permission: true,
        role: ['admin', 'agent'],
        visiable: true,
      },
      component: () => import("../views/gmRecharge.vue")
    },
    {
      path: "/shutdownList",
      name: "shutdownList",
      meta: {
        title: '国美停机',
        permission: true,
        role: ['admin', 'agent'],
        visiable: true,
      },
      component: () => import("../views/shutdownList.vue")
    },
    {
      path: "/gmAbnormalCallListNew",
      name: "gmAbnormalCallListNew",
      meta: {
        title: '国美异常话单',
        permission: true,
        role: ['admin', 'agent'],
        visiable: true,
      },
      component: () => import("../views/gmAbnormalCallListNew.vue")
    },
    {
      path: "/telephoneInspection",
      name: "telephoneInspection",
      meta: {
        title: '关键词列表',
        permission: true,
        role: ['admin', 'agent'],
        visiable: true,
      },
      component: () => import("../views/telephoneInspection.vue")
    },
    {
      path: "/telephoneInspectionType",
      name: "telephoneInspectionType",
      meta: {
        title: '类别管理',
        permission: true,
        role: ['admin', 'agent'],
        visiable: true,
      },
      component: () => import("../views/telephoneInspectionType.vue")
    }, {
      path: "/telephoneInspectionList",
      name: "telephoneInspectionList",
      meta: {
        title: 'AI质检',
        permission: true,
        role: ['admin', 'agent'],
        visiable: true,
      },
      component: () => import("../views/telephoneInspectionList.vue")
    }, {
      path: "/inspectionServer",
      name: "inspectionServer",
      meta: {
        title: '语音检测服务器',
        permission: true,
        role: ['admin', 'agent'],
        visiable: true,
      },
      component: () => import("../views/inspectionServer.vue")
    },
    {
      path: "/newPage",
      name: "newPage",
      meta: {
        title: '测试页面',
        permission: true, // 如果需要权限控制
        role: ['admin', 'agent'] // 设置可访问的角色
      },
      component: () => import("../views/NewPage.vue")
    },
    {
      path: "/quartz-task-management",
      name: "QuartzTaskManagement",
      meta: {
        title: '定时任务管理',
        permission: true,
        role: ['admin', 'agent']
      },
      component: () => import("../views/job/JobManager.vue")
    },
    {
      path: "/dxtPackageTopUpLog",
      name: "DxtPackageTopUpLog",
      meta: {
        title: '迪信通充值日志',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/DxtPackageTopUpLog.vue")
    },
    {
      path: "/dijiaNumberPool",
      name: "DijiaNumberPool",
      meta: {
        title: '迪迦号码池',
        permission: true,
        role: ['admin'],
        visiable: true,
      },
      component: () => import("../views/DijiaNumberPool.vue")
    }
  ]
}, {
  path: "/login",
  name: "Login",
  meta: {
    title: '登录',
    loginRequest: true
  },
  component: () => import("../views/Login.vue")
}];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  if (localStorage.getItem('webName')) {
    document.title = `${to.meta.title} | ${localStorage.getItem('webName')}`;
  }
  const role = localStorage.getItem('ms_role');
  if (!role && to.path !== '/login') {
    next('/login');
  } else if (to.meta.permission) {
    // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
    to.meta.role.indexOf(role) >= 0 ? next() : next('/403');
  } else {
    next();
  }
});
// router.afterEach(function(to,form){
//
// })

export default router;